import { useState } from 'react'
import { Button, Card, Col, Form, Row, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import { toast } from 'react-toastify';
import { loginSucess } from '../redux/user/actions';

const ForgotPassword = () => {
    const [formData, setFormData] = useState({
        email: "",
        newPassword: "",
        confirmPassword: "",
    });

    const [passwordVisible, setPasswordVisible] = useState(false);
    const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const { userId, token } = useSelector((state) => state.login);
    const navigate = useNavigate();
    const dispatch = useDispatch()

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const togglePasswordVisibility = () =>
        setPasswordVisible((prev) => !prev);

    const toggleConfirmPasswordVisibility = () =>
        setConfirmPasswordVisible((prev) => !prev);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            if (formData.newPassword !== formData.confirmPassword) {
                alert("Passwords do not match!");
                return;
            }

            const headers = {
                Authorization: `Bearer ${token}`,
            };

            const payload = {
                _id: userId,
                password: formData.newPassword,
                email: formData.email ? formData.email : null
            }

            const response = await axios.put("admin-user-management/reset-password", payload, { headers });
            if (response?.status === 200) {

                const userData = response.data.data.user;
                console.log("Response :", response );
                console.log("userData :", userData);
                
                dispatch(
                    loginSucess({
                        token: token,
                        userId: userData?._id,
                        userRole: response?.data?.data?.user?.role,
                        user: userData,
                        email: userData.email,
                        access: userData.access
                    })
                )

                toast.success(response.data.data.message, {
                    position: "top-center",
                    autoClose: 3000,
                    theme: "light",
                });
            }
            navigate("/");
        } catch (error) {
            console.error("Error resetting password:", error);
            if ( error.response && error.response?.data?.status === false && error.response?.status === 406 ) {
                let errorMessage = error?.response?.data?.error;
                toast.error(errorMessage, {
                    position: "top-center",
                    autoClose: 3000,
                    theme: "light",
                });
            } else if ( error.response && error.response?.data?.status === false && error.response?.status === 412 ) {
                let errorMessage = error?.response?.data?.data?.message;
        
                toast.error(errorMessage, {
                    position: "top-center",
                    autoClose: 3000,
                    theme: "light",
                });
            } else if ( error.response && error.response?.data?.status === false && error.response?.status === 404 ) {
                let errorMessage = error?.response?.data?.data?.message;
        
                toast.error(errorMessage, {
                    position: "top-center",
                    autoClose: 3000,
                    theme: "light",
                });
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="page-sign d-block py-0">
            <Row className="g-0">
                <Col md="7" lg="5" xl="4" className="col-wrapper">
                    <Card className="card-sign">
                        <Card.Header>
                            <Link to="/" className="header-logo mb-5">
                                xpanse admin
                            </Link>
                            <Card.Title className='text-success fw-semibold'>Reset Password</Card.Title>
                            <Card.Text>
                                Please enter your new password below.
                            </Card.Text>
                        </Card.Header>
                        <Card.Body>
                            <Form onSubmit={handleSubmit}>
                                <div className="mb-4">
                                    <Form.Label>Email address</Form.Label>
                                    <Form.Control
                                        name="email"
                                        type="text"
                                        placeholder="Enter your email address"
                                        onChange={handleChange}
                                        value={formData.email}
                                    />
                                </div>
                                {/* New Password */}
                                <div className="mb-4" style={{ position: "relative" }}>
                                    <Form.Label>New Password</Form.Label>
                                    <Form.Control
                                        name="newPassword"
                                        type={passwordVisible ? "text" : "password"}
                                        placeholder="Enter new password"
                                        onChange={handleChange}
                                        value={formData.newPassword}
                                    />
                                    <Form.Group
                                        onClick={togglePasswordVisibility}
                                        style={{
                                            cursor: "pointer",
                                            position: "absolute",
                                            top: "68%",
                                            right: "20px",
                                            transform: "translateY(-50%)",
                                        }}
                                    >
                                        {passwordVisible ? (
                                            <i className="bi bi-eye"></i>
                                        ) : (
                                            <i className="bi bi-eye-slash"></i>
                                        )}
                                    </Form.Group>
                                </div>

                                {/* Confirm Password */}
                                <div className="mb-4" style={{ position: "relative" }}>
                                    <Form.Label>Confirm Password</Form.Label>
                                    <Form.Control
                                        name="confirmPassword"
                                        type={confirmPasswordVisible ? "text" : "password"}
                                        placeholder="Confirm new password"
                                        onChange={handleChange}
                                        value={formData.confirmPassword}
                                    />
                                    <Form.Group
                                        onClick={toggleConfirmPasswordVisibility}
                                        style={{
                                            cursor: "pointer",
                                            position: "absolute",
                                            top: "68%",
                                            right: "20px",
                                            transform: "translateY(-50%)",
                                        }}
                                    >
                                        {confirmPasswordVisible ? (
                                            <i className="bi bi-eye"></i>
                                        ) : (
                                            <i className="bi bi-eye-slash"></i>
                                        )}
                                    </Form.Group>
                                </div>

                                {/* Submit Button */}
                                <Button
                                    type="submit"
                                    variant="primary"
                                    className="btn-sign"
                                    disabled={isLoading}
                                >
                                    {isLoading ? (
                                        <>
                                            <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            />{" "}
                                            Resetting...
                                        </>
                                    ) : (
                                        "Reset Password"
                                    )}
                                </Button>
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
                {/* <Col className="d-none d-lg-block">
                    <img src={bg1} className="auth-img" alt="" />
                </Col> */}
            </Row>
        </div>
    );
}

export default ForgotPassword
